fx.ns("shared.popups", class Offline extends fx.components.Popup{
    
    constructor(data)
    {
        super(data);

        this.contentWidth = 520;
        this.contentHeight = 280;
        this.showClose = false;
    }

    create()
    {
        super.create();
        
        let box = new fx.components.VBox();
        box.addChild(new fx.components.Text({text: fx.text("Un problème avec votre connexion Internet ?"), className:"title center"}), {width:"100%"});
        box.addChild(new fx.components.Text({text:fx.text("Notre application n'arrive pas à se connecter à nos serveurs pour sauvegarder votre travail."), className:"text center"}), {width:"100%"});
        box.addChild(new fx.components.Text({text:fx.text("Tentative de reconnexion...") , className:"text connecting center"}), {width:"100%"});

        this.addChild(box, {width : "100%", height : "auto", top: fx.browser.isTablet ? "center" : 25 , left : 0});
        
        this.cancelButton = new fx.components.Button({label : fx.text("Fermer")});
        this.addChild(this.cancelButton, {bottom:20, height:60, width : 200, left:"center"});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.cancelButton);
    }

});